export const ProgrammingAssignmentsSubViews = {
  DEFAULT: 'instructions',
  INSTRUCTIONS: 'instructions',
  SUBMISSIONS: 'submission',
  DISCUSSIONS: 'programming.discussions', // This needs to be different than "discussions" or else there's an invariant violation ¯\_(ツ)_/¯
  SHARING: 'sharing',
} as const;

export type ProgrammingAssignmentsSubView =
  (typeof ProgrammingAssignmentsSubViews)[keyof typeof ProgrammingAssignmentsSubViews];
